<template>
  <div class="itemIndex" ref="itemIndex">
    <van-skeleton class="agentTitle" avatar-size="50px" title avatar :row="2" :loading="agentShow">
      <div class="agentTitle">
        <div class="Lf">
          <van-card centered :thumb="hostUrl+agentData.logo">
            <div slot="title" class="titleDiv">{{agentData.agentName}}</div>
            <div slot="desc" class="descDiv">
              <van-cell :title="agentData.email" icon="envelop-o" />
              <van-cell :title="agentData.mobile" icon="phone-circle-o" />
            </div>
          </van-card>
        </div>
        <div class="rt">
          <!-- <div>{{agentData.brokeName}}</div> -->
          <van-image :src="hostUrl+agentData.brokeLogo" />
        </div>
      </div>
    </van-skeleton>
    <div class="content">
      <van-sticky>
        <van-search v-model="seek" show-action placeholder="Search" @search="onSearch">
          <template #action>
            <div @click="onSearch">Search</div>
          </template>
        </van-search>
        <van-dropdown-menu>
          <van-dropdown-item @change="dropdMenuFn" v-model="from.location" :options="district" />
          <van-dropdown-item @change="dropdMenuFn" v-model="from.unitType" :options="unitTypeList" />
          <van-dropdown-item @change="dropdMenuFn" v-model="from.projectArea" :options="Range" />
          <van-dropdown-item title="More" ref="More">
            <div class="MoreDiv">
              <div class="MoreBox">
                <van-divider :style="{ padding: '0 10px', marginTop: '0'  }">Common</van-divider>
                <div class="checkboxDiv">
                  <van-checkbox-group ref="Common" v-model="from.common" direction="horizontal" :max="1">
                    <van-checkbox :name="item.value" v-for="(item, index) in Common" :key="index">{{item.text}}</van-checkbox>
                  </van-checkbox-group>
                </div>
              </div>
              <div class="MoreBox">
                <van-divider :style="{  padding: '0 10px' }">Project Type</van-divider>
                <div class="checkboxDiv">
                  <van-checkbox-group ref="ProjectType" v-model="from.projectType" direction="horizontal" :max="1">
                    <van-checkbox :name="item.value" v-for="(item, index) in ProjectType" :key="index">{{item.text}}</van-checkbox>
                  </van-checkbox-group>
                </div>
              </div>
              <div class="MoreBox">
                <van-divider :style="{ padding: '0 10px', marginTop: '0'  }">Tenure</van-divider>
                <div class="checkboxDiv">
                  <van-checkbox-group ref="Tenure" v-model="from.tenure" direction="horizontal" :max="1">
                    <van-checkbox :name="item.value" v-for="(item, index) in Tenure" :key="index">{{item.text}}</van-checkbox>
                  </van-checkbox-group>
                </div>
              </div>
            </div>
            <div class="MoreBtn">
              <van-button type="default" @click.native="resetBtn">Reset</van-button>
              <van-button type="default" class="affirmBtn" @click.native="Confirm">Confirm</van-button>
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
      </van-sticky>
      <div class="projectCt">
        <van-list :immediate-check="false" v-model="loadingMove" :finished="finished" @load="onLoad">
          <div class="projectBox" v-for="(item, index) in ProjectList" :key="index">
            <div class="projectBoxImg" @click="goInfo(item)">
              <van-image :error-icon="''" :src="hostUrl+item.mainImage+(img_suffix || defaultImgResize)" />
            </div>
            <div class="textBox">
              <van-cell class="head">
                <template #title>
                  <van-tag v-if="item.projectStatus == 'By BUC'" type="warning">{{item.projectStatus}}</van-tag>
                  <van-tag v-if="item.projectStatus == 'Completed'" type="success">{{item.projectStatus}}</van-tag>
                  <van-tag v-if="item.projectStatus == 'TOP soon'">{{item.projectStatus}}</van-tag>
                  <span class="custom-title">{{item.projectName}}</span>
                </template>
              </van-cell>
              <van-cell :title="item.streetAddress" icon="location-o" />
              <van-cell :title="item.projectType" />
            </div>
          </div>
        </van-list>
        <van-empty v-if="!ProjectList.length" description="No Content" />
      </div>
    </div>
    <div class="footer">
      <!-- <van-grid :column-num="3">
        <van-grid-item icon="phone-circle" />
        <van-grid-item icon="chat" />
        <van-grid-item class="wasAp" icon="comment-circle" />
      </van-grid>-->
      <van-row type="flex">
        <van-col span="8">
          <a style="color: #2c3e50" :href="`tel:${agentData.mobile}`">
            <van-icon name="phone" size="30" />
          </a>
        </van-col>
        <van-col span="8">
          <a style="color: #2c3e50" :href="`sms:${agentData.mobile}`">
            <van-icon name="chat" size="30" />
          </a>
        </van-col>
        <van-col span="8">
          <van-icon @click="whatsAppFn(agentData.mobile)" class="whatsapp" name="phone-circle" size="30" />
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import JsonData from '../../assets/json/jsonData.json'
export default {
  data () {
    return {
      RouteInfo: {},
      hostUrl: '',
      agentShow: true,
      agentData: {},
      seek: '',
      JsonData: JsonData,
      from: {
        location: 'All',
        unitType: 'All Bedroom',
        projectArea: 'All Region',
        tenure: [],
        projectType: [],
        common: []
      },
      Tenure: JsonData.Tenure,
      ProjectType: JsonData.ProjectType,
      loadingMove: false,
      finished: false,
      ProjectList: [],
      pageNo: 1,
      pageSize: 16,
      totalPage: 0,
      Common: [
        {
          text: 'By BUC',
          value: 'By BUC'
        },
        {
          text: 'TOP soon',
          value: 'TOP soon'
        },
        {
          text: 'Completed',
          value: 'Completed'
        },
        {
          text: 'VR',
          value: 'VR'
        }
      ],
      img_suffix: "",
      defaultImgResize: "?x-oss-process=image/auto-orient,1/interlace,1/resize,p_70/quality,q_100"
    }
  },
  computed: {
    district () {
      return JsonData.district[0].province.map(i => {
        return {
          text: i,
          value: i.substring(0, 3)
        }
      })
    },
    unitTypeList () {
      return JsonData.unitTypeList.map(i => {
        return {
          text: i,
          value: i
        }
      })
    },
    Range () {
      return JsonData.Range.map(i => {
        return {
          text: i,
          value: i
        }
      })
    }
  },
  watch: {
    totalPage (val) {
      if (val) {
        this.finished = false
      } else {
        this.finished = true
      }
    }
  },
  created () {
    this.$removeScrollNum('itemIndex')
  },
  activated () {
    this.$SetScroll(this.$refs.itemIndex, 'itemIndex')
  },
  mounted () {
    this.$KeepScrollTop(this.$refs.itemIndex, 'itemIndex')
    console.log("itemIndex")
    this.getShareParams()
    const head = document.getElementsByTagName('head')[0]
    let link = document.createElement('link')
    link.rel = 'canonical'
    link.href = `https://www.ecoprop.com`
    console.log(link)
    head.appendChild(link)
  },
  methods: {
    getShareParams () {
      let param = this.$route.params
      console.log(param)
      this.$Post(this.$api.getShareParams, param)
        .then(res => {
          if (res.code === '0') {
            this.RouteInfo = res.datas
            this.querySysConfig()
            this.getEmailSetting()
            this.queryAgentProjectList()
          }
        })
    },
    onSearch () {
      this.dropdMenuFn()
      // console.log('搜索')
    },
    dropdMenuFn (item) {
      this.pageNo = 0
      this.ProjectList = []
      this.onLoad()
    },
    resetBtn () {
      this.$refs.ProjectType.toggleAll(false)
      this.$refs.Tenure.toggleAll(false)
      this.$refs.Common.toggleAll(false)
      this.$refs.More.toggle()
      this.dropdMenuFn()
    },
    Confirm () {
      this.dropdMenuFn()
      this.$refs.More.toggle()
    },
    onLoad () {
      this.pageNo++
      this.queryAgentProjectList()
      if (this.pageNo > this.totalPage) {
        this.finished = true
      }
    },
    querySysConfig () {
      this.$Post(this.$api.querySysConfig, {}).then(res => {
        if (res.code == 0) {
          this.hostUrl = res.datas.img_url
          sessionStorage.setItem('hostUrl', res.datas.img_url)
          this.img_suffix = res.datas['img_resize_other_app'];
        }
      })
    },
    getEmailSetting () {
      let self = this
      this.$Post(this.$api.getEmailSetting, {
        agentId: self.RouteInfo.agentId
      }).then(res => {
        if (res.code == 0) {
          this.agentData = res.datas
          this.agentShow = false
          if (this.agentData.signature) {
            this.agentData.signature = this.agentData.signature
              .split('\n')
              .join('<br>')
          }
          document.title = res.datas.brokeName
        }
      })
    },
    queryAgentProjectList () {
      let obj = JSON.parse(JSON.stringify(this.from))
      let fromData = {
        location: obj.location == 'All' ? '' : obj.location,
        unitType: obj.unitType == 'All Bedroom' ? '' : obj.unitType,
        projectArea: obj.projectArea == 'All Region' ? '' : obj.projectArea,
        tenure: obj.tenure[0] ? obj.tenure[0] : '',
        projectType: obj.projectType[0] ? obj.projectType[0] : '',
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        projectName: this.seek,
        brokeId: '1',
        agentId: this.RouteInfo.agentId,
        completionStatus: this.from.common[0]
          ? this.from.common[0] != 'VR'
            ? this.from.common[0]
            : ''
          : '',
        isIvt: this.from.common[0]
          ? this.from.common[0] == 'VR'
            ? '1'
            : ''
          : ''
      }
      this.$Post(this.$api.queryAgentProjectList, fromData, true).then(res => {
        if (res.code == 0) {
          this.totalPage = this.$pageCount(res.datas.count, this.pageSize)
          this.ProjectList = this.ProjectList.concat(res.datas.lists)
          this.loadingMove = false
        }
      })
    },
    goInfo (item) {
      console.log(item)
      this.$router.push({
        path: '/' + item.abbreviation + '/' + this.$route.params.regNum,
      })
    },
    whatsAppFn (mobile) {
      let num = parseFloat(mobile.replace(/[^0-9]/gi, ''))
      let url = `https://wa.me/${num}`
      window.open(url)
    }
  }
}
</script>

<style lang="less">
.itemIndex {
  height: 100%;
  overflow-y: scroll;
  position: relative;
  background: #f4f4f4;
  .agentTitle {
    background: #fff;
    box-shadow: 0 0 5px #ddd;
    padding: 0 10px;
    position: relative;
    .van-card__header {
      align-items: center;
    }
    .van-card__thumb {
      width: 60px;
      height: 60px;
    }
    .van-card {
      background: #fff;
      padding: 0;
      .van-card__thumb img {
        border-radius: 50%;
      }
      .titleDiv {
        font-size: 14px;
        font-weight: 600;
        color: #000;
      }
      .descDiv {
        padding: 0;
        .van-cell::after {
          border: 0;
        }
        .van-cell {
          padding: 0;
          font-size: 12px;
        }
      }
    }
    .Lf {
      float: left;
      width: 70%;
    }
    .rt {
      float: right;
      position: absolute;
      // width: 30%;
      left: 71%;
      font-size: 16px;
      font-weight: 600;
      right: 10px;
      text-align: center;
      height: 35px;
      // line-height: 30px;
      top: 50%;
      margin-top: -17px;
      // div {
      //   overflow: hidden;
      //   text-overflow: ellipsis;
      //   white-space: nowrap;
      // }
      .van-image {
        width: 100%;
        height: 100%;
        img {
          object-fit: contain !important;
        }
      }
    }
  }
  .agentTitle::after {
    clear: both;
    content: "";
    display: block;
    height: 0;
  }
  .content {
    background: #f4f4f4;
    padding-bottom: 30px;
    .van-dropdown-menu__title {
      font-size: 12px;
    }
    .van-dropdown-item__option {
      font-size: 12px;
    }
    .MoreDiv {
      padding: 0 10px;
      h1 {
        margin: 10px 0;
        font-size: 13px;
        font-weight: 100;
      }
      .MoreBox {
        .checkboxDiv {
          .van-checkbox {
            margin-bottom: 16px;
          }
          .van-checkbox__icon {
            display: none;
          }
          .van-checkbox__label {
            border: 1px solid #ddd;
            color: #666;
            padding: 2px 5px;
            border-radius: 3px;
            font-size: 12px;
          }
          .van-checkbox__icon--checked + .van-checkbox__label {
            border-color: #1989fa;
            color: #1989fa;
          }
        }
      }
    }
    .MoreBtn {
      display: flex;
      .van-button--default {
        border: 0;
        width: 50%;
        padding: 0;
        background: #f4f4f4;
        border-radius: 0;
      }
      .affirmBtn {
        background: #999;
        color: #fff;
      }
    }
    .projectCt {
      padding: 10px;
      .projectBox {
        border-radius: 5px;
        background: #fff;
        margin-bottom: 20px;
        box-shadow: 0 0 8px #ddd;
        .projectBoxImg {
          // min-height: 50px;
          width: 100%;
          .van-image {
            width: 100%;
            height: 100%;
            // min-height: 25vh;
            img {
              border-top-right-radius: 5px;
              border-top-left-radius: 5px;
            }
            .van-image__error {
              background: url("../../assets/img/404.png") no-repeat 0 0;
              background-size: 100% 100%;
              border-top-right-radius: 5px;
              border-top-left-radius: 5px;
              min-height: 30vh;
              display: block;
              position: relative;
              font-size: auto;
            }
          }
        }
        .van-cell::after {
          display: none;
          padding: 0;
        }
        .van-cell {
          padding: 0;
        }
        .textBox {
          padding: 10px;
          padding-top: 5px;
          .head {
            font-weight: 600;
            font-size: 15px;
          }
        }
      }
    }
  }
  .footer {
    position: fixed;
    height: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    .van-row {
      height: 100%;
      background: #fff;
      align-items: center;
      text-align: center;
    }
    a {
      display: inline-block;
    }

    .whatsapp::before {
      content: "";
      height: 30px;
      width: 30px;
      background: url("../../assets/img/whatsapp.png") no-repeat 0 0;
      background-size: 100% 100%;
    }
  }
  .van-divider {
    margin: 0px 0 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/items/itemIndex.vue